import select from 'dom-select';

export default (el) => {
  const ui = {
    el,
    image: select('.image__image', el)
  };

  const { src } = ui.el.dataset;
  const { srcset } = ui.el.dataset;

  if ('IntersectionObserver' in window
    && 'IntersectionObserverEntry' in window
    && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
    const loadImage = () => {
      const imagePromise = (obj) => new Promise((resolve) => {
        const loadedImage = new Image(); // eslint-disable-line

        loadedImage[obj.type] = obj.src;
        loadedImage.onload = () => resolve(obj);
        loadedImage.onerror = () => {
          throw new Error(`Unable to load ${obj.type} from ${obj.src}`);
        };
      });

      const obj = srcset ? { src: srcset, type: 'srcset' } : { src, type: 'src' };

      // eslint-disable-next-line no-shadow
      imagePromise(obj).then(() => {
        if (!ui.el.classList.contains('image--background')) {
          ui.image.src = src;
          if (srcset) ui.image.srcset = srcset;
        } else {
          ui.el.style.backgroundImage = `url(${src})`;
        }

        setTimeout(() => {
          ui.el.classList.remove('is-lazy');
        }, 500);
      }).catch((e) => {
        console.log(e.message); // eslint-disable-line
      });
    };

    const addBodyEvents = () => {
      window.addEventListener('DOMContentLoaded', () => {
        const imageObserver = new IntersectionObserver((entries) => { // eslint-disable-line
          entries.forEach((image) => {
            if (image.isIntersecting) {
              loadImage();
            }
          });
        });

        imageObserver.observe(ui.el);
      });
    };

    const init = () => {
      addBodyEvents();
    };

    init();
  } else if (!ui.el.classList.contains('image--background')) {
    ui.image.src = src;
    ui.image.srcset = srcset;
  } else {
    ui.el.style.backgroundImage = `url(${src})`;
  }
};
